import { useAccount, useWriteContract } from "wagmi";
import { PRESALE_CONTRACT_ADDRESS } from "../../../constants";
import { presaleAbi } from "../../../abis/presaleAbi";
import { handleWriteContractError } from "../../../helpers";
import { toast } from "react-toastify";

export function useClaim() {
  const userAccount = useAccount();
  const { data, error, writeContractAsync, isPending, isSuccess } =
    useWriteContract();

  const claim = async (presaleId: bigint) => {
    try {
      return await writeContractAsync({
        address: PRESALE_CONTRACT_ADDRESS,
        abi: presaleAbi,
        functionName: "claim",
        args: [userAccount.address as `0x${string}`, presaleId],
      }).then(() => toast.success("Transaction successfully submitted"));
    } catch (error) {
      return null;
    }
  };

  if (error) {
    return handleWriteContractError(error);
  }

  if (!data && !claim) return null;

  return { claim, claimHash: data, error, isPending, isSuccess };
}
